import { createContext, useContext, type ReactNode } from "react";

import { apiClient, type ApiClient } from "./client";

/** Injected so screens never reach for a module singleton and tests can supply a stub. */
const ApiContext = createContext<ApiClient>(apiClient);

export function ApiProvider({
  client = apiClient,
  children,
}: {
  client?: ApiClient;
  children: ReactNode;
}): React.JSX.Element {
  return <ApiContext.Provider value={client}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiClient {
  return useContext(ApiContext);
}
